import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDeleteHolidayMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (holidayId: number) => {
      return ScheduleConfigService.scheduleConfigServiceDeleteHoliday({
        path: { id: holidayId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.holidays.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
      ]);
    },
  });
};
